/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, RIKEN){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon" data-view="pc"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg><img src="/common/images/arrow_left_waku.svg" class="icon" data-view="tablet sp" /></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon" data-view="pc"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg><img src="/common/images/arrow_right_waku.svg" class="icon" data-view="tablet sp" /></button>';
	const $path = location.pathname;

	// =============================================================================
	// 会社情報TOP
	const mainVisAnimation = () => {
		if($('.js-animation-mainVis').length) {
			const anime = 'is-animation';
			// メインビジュアル
			$('.js-animation-mainVis').on('inview', (event, isInView) => {
				$('.top-mainVis-bg').addClass(anime);
				$('.top-mainVis-h1').addClass(anime);
			});
		}
	}
	// おすすめコンテンツ
	const recommendContentsSlider = () => {
		const anime = 'is-animation';
		const thisSlider = $('.js-recommend-slider');
		const thisSliderDots = thisSlider.next('.mod-slider-dots');
		if(thisSlider.length) {
			thisSlider.slick({
				infinite: true,
				speed: 1000,
				autoplaySpeed: 4000,
				autoplay: true,
				slidesToShow: 4,
				arrows: true,
				dots: true,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
				appendDots: thisSliderDots,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 2,
							arrows: false,
							speed: 500,
						}
					},{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							arrows: false,
							speed: 500,
						}
					}
				]
			});
			// 再生ボタン
			thisSliderDots.find('button.__play').on('click', () => {
				thisSliderDots.toggleClass(a);
				thisSlider.slick('slickPlay');
			});
			// 停止ボタン
			thisSliderDots.find('button.__pause').on('click', () => {
				thisSliderDots.toggleClass(a);
				thisSlider.slick('slickPause');
			});
		}
		
		$('.js-animation-recommend').on('inview', (event, isInView) => {
			$('.js-animation-recommend').addClass(anime);
		});
	};

	// おすすめコンテンツ
	const learnContentsSlider = () => {
		const anime = 'is-animation';
		const thisSlider = $('.js-learn-slider');
		const thisSliderDots = thisSlider.next('.mod-slider-dots');
		if(thisSlider.length) {
			thisSlider.slick({
				infinite: true,
				speed: 1000,
				autoplaySpeed: 4000,
				autoplay: true,
				slidesToShow: 3,
				arrows: true,
				dots: true,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
				appendDots: thisSliderDots,
				responsive: [
					{
						breakpoint: 1025,
						settings: {
							slidesToShow: 2,
							speed: 500,
						}
					},{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							speed: 500,
						}
					}
				]
			});
			// 再生ボタン
			thisSliderDots.find('button.__play').on('click', () => {
				thisSliderDots.toggleClass(a);
				thisSlider.slick('slickPlay');
			});
			// 停止ボタン
			thisSliderDots.find('button.__pause').on('click', () => {
				thisSliderDots.toggleClass(a);
				thisSlider.slick('slickPause');
			});
		}
	};

	// =============================================================================
	const googleMap = () => {
		let mapPin;
		$(window).on('resize', (e) => {
			let winW = $(window).width();
			if(winW > 1024) {
				mapPin = '/common/images/com_map_ic01.png';
			} else {
				mapPin = '/common/images/com_map_ic01_sp.png';
			}
		}).resize();

		function createMaps(_e, _n) {
			var map = $(_e).attr('id'),
			box = document.getElementById(map),
			lat = $(_e).attr('data-latitude'),
			lon = $(_e).attr('data-longitude'),
			latlng = new google.maps.LatLng(lat, lon),
			icon = mapPin,
			mapOptions,
			marker;
			//Google Mapを表示
			google.maps.event.addDomListener(window, 'load', function() {
				mapOptions = {
					zoom: 18,
					center: latlng,
					mapTypeId: google.maps.MapTypeId.ROADMAP
				};
				marker = new google.maps.Marker({
					position: latlng,
					icon: icon,
					map: new google.maps.Map(box, mapOptions)
				});
			});
		}
		$('.js-googlemap').each(function(e) {
			var self = this,
			count = e + 1;
			$(this).attr('id', 'map-' + count);
			createMaps(self);
		});
	};

	// =============================================================================
	// 早わかり理研ビタミン
	const infographicAnimation = () => {
		const anime = 'is-animation';
		$('.js-animation').each((idx, ele) => {
			$(ele).on('inview', (event, isInView) => {
				$(ele).addClass(anime);
				$(ele).find('.js-animation-head').addClass(anime);
				$(ele).find('.js-animation-block').addClass(anime);
			});
		});
	}
	// =============================================================================
	// 商品開発ストーリー
	const productsHistoryAnimation = () => {
		const anime = 'is-animation';
		$('.js-animation').each((idx, ele) => {
			$(ele).on('inview', (event, isInView) => {
				$(ele).addClass(anime);
				$(ele).find('.js-animation-head').addClass(anime);
				$(ele).find('.js-animation-block').addClass(anime);
			});
		});
	}
	const productsHistoryModal = () => {
		let scrollTopNow;
		if($('.js-modalBtn').length) {
			$('.js-modalBtn').on('click', (e) => {
				let $this = $(e.currentTarget);
				let thisModalHtml = $this.parent('.mod-button').next('.js-modalItem').prop('outerHTML');
				fixedOnContainer();

				$('.js-modal-base').append(thisModalHtml);
				$('.js-modal').addClass(a);
				$('.js-modal-overlay').on('click', () => {
					$('.js-modal').removeClass(a);
					$('.js-modal').find('.js-modalItem').remove();
					$('.js-modal-overlay').off();
					fixedOffContainer();
				});
				$('.js-modal-close').on('click', () => {
					$('.js-modal').removeClass(a);
					$('.js-modal').find('.js-modalItem').remove();
					$('.js-modal-close').off();
					fixedOffContainer();
				});
			});
		}

		const fixedOnContainer = () => {
			scrollTopNow = $(window).scrollTop();
			$('.container').css({
				position: 'fixed',
				width: '100%',
				top: -1 * scrollTopNow,
				left: 0
			});
			$('body').addClass(f);
		};
		const fixedOffContainer = () => {
			$('.container').css({
				position: 'static'
			});
			$('body').removeClass(f);
			$(window).scrollTop(scrollTopNow);
		};
	}

	// =============================================================================
	// 身近なところに理研ビタミン
	const discoverAnimation = () => {
		const anime = 'is-animation';
		$('.js-animation').each((idx, ele) => {
			$(ele).on('inview', (event, isInView) => {
				$(ele).addClass(anime);
				$(ele).find('.js-animation-head').addClass(anime);
				$(ele).find('.js-animation-block').addClass(anime);
			});
		});
	}




	// =============================================================================
	mainVisAnimation();
	recommendContentsSlider();
	learnContentsSlider();

	if($('.js-googlemap').length) {
		googleMap();
	}

	if($path === '/corporate/info/infographic/' || $path === '/corporate/info/infographic/index.html' ||
		$path === '/en/corporate/infographic/' || $path === '/en/corporate/infographic/index.html') {
		infographicAnimation();
	}
	if($path === '/corporate/info/products_history/' || $path === '/corporate/info/products_history/index.html' ||
		$path === '/en/corporate/products_history/' || $path === '/en/corporate/products_history/index.html') {
		productsHistoryAnimation();
	}
	if($path === '/corporate/info/discover/' || $path === '/corporate/info/discover/index.html') {
		discoverAnimation();
	}
	productsHistoryModal(); // 「アプリケーション＆イノベーションセンター」でも使用


})(window.jQuery, window.RIKEN);
